import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { WorkTeamsDeleteDialog } from 'pages/Finance/WorkTeams/components/WorkTeamsDeleteDialog';
import { useEditWorkGroupAccess } from 'pages/Finance/WorkTeams/hooks/useEditWorkGroupAccess';
import { useShowController } from 'react-admin';
import { DeleteButton, EditLinkButton } from 'shared/mui/Buttons';
import { UserActionsIconButton } from 'shared/mui/IconButtons/UserActionsIconButton/UserActionsIconButton';
import { ShowPage } from 'shared/react-admin/Pages/ShowPage/ShowPage';
import { WorkTeamsShowTable } from 'shared/widgets/WorkTeamsShowTable/WorkTeamsShowTable';
import { Permission } from 'types/embedded/permission';
import { WorkTeam } from 'types/embedded/workTeam';

export const WorkTeamsShow = (): JSX.Element => {
  const { hasResourcePermissions, hasResourceAccess } = usePermissions();
  const { record } = useShowController();

  const {
    handleOpenRecordModal: handleOpenRecordModalDelete,
    openRecordModal: openRecordModalDelete,
    handleCloseRecordModal: handleCloseRecordModalDelete,
  } = useRecordModal<WorkTeam>();

  const { hasEditWorkGroupAccess } = useEditWorkGroupAccess();

  return (
    <>
      <ShowPage
        actions={
          hasResourceAccess(Resources.UserActions)
            ? [<UserActionsIconButton entityName="work_team" key="user-action-link" />]
            : undefined
        }
        listName="Рабочие группы"
        rightActionsSlot={[
          hasEditWorkGroupAccess(record) &&
            hasResourcePermissions(Resources.WorkTeams, [Permission.Full, Permission.Delete]) && (
              <DeleteButton onClick={() => handleOpenRecordModalDelete()} variant="outlined" />
            ),
          hasEditWorkGroupAccess(record) &&
            hasResourcePermissions(Resources.WorkTeams, [Permission.Full, Permission.Update]) && (
              <EditLinkButton variant="contained" />
            ),
        ]}
        title="Рабочая группа"
      >
        <WorkTeamsShowTable />
      </ShowPage>
      {openRecordModalDelete && (
        <WorkTeamsDeleteDialog
          onClose={handleCloseRecordModalDelete}
          open={openRecordModalDelete}
          record={record}
        />
      )}
    </>
  );
};
